import { getAuthAsync } from "./auth";
import { serverUrl } from "./ConfigHolder";
import { Sentence } from "./models/Sentence";
import { sentenceFactory } from "./models/sentenceFactory";

// Helper to attach a precomputed sentences array aligned with phrases
function attachSentences(content) {
  if (!content || !Array.isArray(content.phrases)) {
    return content;
  }

  // Ensure phrase IDs exist first
  Sentence.ensurePhraseIds(content);

  content.sentences = content.phrases.map((_, idx) =>
    sentenceFactory(content, idx, { dontUpdateContent: true })
  );

  return content;
}

async function loadObjectFromFile(filename) {
    try {
      const response = await fetch(`/${filename}`);  
      if (!response.ok) {
        throw new Error('Failed to load file');
      }
  const data = await response.json();
  // Ensure each phrase has a Mongo-like _id and attach sentences
  const withSentences = attachSentences(data);
  // console.log('Loaded object:', withSentences);
  return withSentences;
    } catch (error) {
      console.error('Error loading file:', error);
      return null;
    }
  }

  async function loadObjectFromServer(learn, base, contentType, logout) {
    const params = { learn, base, content: contentType };
    const uri = `${serverUrl}/custom_content_object`;
    try {
  const response = await getAuthAsync(uri, params, 'json');
  let lPhrases = response?.data?.phrases?.length;
  const withSentences = attachSentences(response?.data ?? null);
  console.log(`Loaded object from server: ${learn} ${base} ${contentType} with ${lPhrases} phrases`);
  return withSentences;
    } catch (err) {
      console.error('Error loading object from server:', err);
      if (logout) {
        logout();
      }
      return null;
    }
  }
  
  export { loadObjectFromFile, loadObjectFromServer };
  